'use strict';

module.exports = require('./tree-flatten');


/*****************
 ** WEBPACK FOOTER
 ** ./~/tree-flatten/build/index.js
 ** module id = 1780
 ** module chunks = 0
 **/